var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _path10, _path11, _path12, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIsComing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 141,
    viewBox: "0 0 142 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 43.6064C0.5 42.5019 1.39543 41.6064 2.5 41.6064H16.577C17.6816 41.6064 18.577 42.5019 18.577 43.6064V112.157H0.5V43.6064Z",
    fill: "#E0DFF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6162 14.6621C27.6162 13.5575 28.5116 12.6621 29.6162 12.6621H43.6932C44.7978 12.6621 45.6932 13.5575 45.6932 14.6621V112.156H27.6162V14.6621Z",
    fill: "#E0DFF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7305 27.3262C54.7305 26.2216 55.6259 25.3262 56.7305 25.3262H70.8075C71.9121 25.3262 72.8075 26.2216 72.8075 27.3262V112.158H54.7305V27.3262Z",
    fill: "#E0DFF8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8467 39.9893C81.8467 38.8847 82.7421 37.9893 83.8467 37.9893H97.9237C99.0283 37.9893 99.9237 38.8847 99.9237 39.9893V112.158H81.8467V39.9893Z",
    fill: "#E0DFF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.962 2C108.962 0.895428 109.857 0 110.962 0H125.039C126.143 0 127.039 0.89543 127.039 2V112.157H108.962V2Z",
    fill: "#E0DFF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7636 85.1242L85.7178 93.1758L96.3607 103.826L104.407 95.7747L93.7636 85.1242Z",
    fill: "#2118D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.251 94.4733L95.0559 100.673C93.4944 102.235 93.4944 104.769 95.0559 106.331L126.823 138.121C128.384 139.684 130.916 139.684 132.478 138.121L138.673 131.922C140.234 130.359 140.234 127.826 138.673 126.263L106.906 94.4733C105.344 92.9106 102.812 92.9106 101.251 94.4733Z",
    fill: "#4B43FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.6734,
    cy: 60.601,
    rx: 42.481,
    ry: 42.5112,
    fill: "#4B43FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.6728,
    cy: 60.6002,
    rx: 29.8271,
    ry: 29.8483,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2666_31605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 113
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 43.6064C0.5 42.5019 1.39543 41.6064 2.5 41.6064H16.577C17.6816 41.6064 18.577 42.5019 18.577 43.6064V112.157H0.5V43.6064Z",
    fill: "#C1BEF7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6162 14.6621C27.6162 13.5575 28.5116 12.6621 29.6162 12.6621H43.6932C44.7978 12.6621 45.6932 13.5575 45.6932 14.6621V112.156H27.6162V14.6621Z",
    fill: "#C1BEF7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7305 27.3262C54.7305 26.2216 55.6259 25.3262 56.7305 25.3262H70.8075C71.9121 25.3262 72.8075 26.2216 72.8075 27.3262V112.158H54.7305V27.3262Z",
    fill: "#C1BEF7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8467 39.9893C81.8467 38.8847 82.7421 37.9893 83.8467 37.9893H97.9237C99.0283 37.9893 99.9237 38.8847 99.9237 39.9893V112.158H81.8467V39.9893Z",
    fill: "#C1BEF7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.962 2C108.962 0.895428 109.857 0 110.962 0H125.039C126.143 0 127.039 0.89543 127.039 2V112.157H108.962V2Z",
    fill: "#C1BEF7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2666_31605)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.6728,
    cy: 60.6002,
    rx: 29.8271,
    ry: 29.8483,
    fill: "#A8A3FB"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIsComing);
export default __webpack_public_path__ + "static/media/dashboard_is_coming.a6da868c56427060bb25b13fe7237c0f.svg";
export { ForwardRef as ReactComponent };